import * as React from "react";
import { createContext, useContext, useEffect, useState } from "react";
import Api from "./api";

type ICreditsContext = {
  credits: number | null;
  syncCredits: () => Promise<void>;
};

const defaultCreditsContext: ICreditsContext = {
  credits: null,
  syncCredits: async () => {},
};

const ctx = createContext<ICreditsContext>(defaultCreditsContext);

const { Provider } = ctx;

export const useCredits = () => useContext(ctx);

export const CreditsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [credits, setCredits] = useState<number | null>(
    defaultCreditsContext.credits
  );

  async function syncCredits() {
    const me = await Api.users.me();
    setCredits(me.credits);
  }

  useEffect(() => {
    syncCredits();
  }, []);

  const val: ICreditsContext = {
    credits,
    syncCredits,
  };

  return <Provider value={val}>{children}</Provider>;
};
